import { useState, useEffect } from 'react';
import type { Category } from '@/types/calendar';

export function useCategories() {
  const [ categories, setCategories ] = useState<Category[]>([]);
  const [ isLoading, setIsLoading ] = useState(true);
  const [ error, setError ] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchCategories() {
      try {
        setIsLoading(true);
        const response = await fetch(`${window.curtisCalendar.apiurl}/event-types`);

        if (!response.ok) {
          throw new Error('Failed to fetch categories');
        }

        const json = await response.json();

        if (!json.success) {
          throw new Error('Failed to fetch categories');
        }

        setCategories(json.data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('An unknown error occurred'));
      } finally {
        setIsLoading(false);
      }
    }

    fetchCategories();
  }, []);

  return { categories, isLoading, error };
}
